import React from 'react';
import { ArticleStatus } from '../../types';
import { getStatusColor, getStatusIcon, getStatusText } from '../../utils/articleStatus';

type StatusBadgeSize = 'sm' | 'md' | 'lg';

interface StatusBadgeProps {
  status: ArticleStatus;
  size?: StatusBadgeSize;
  className?: string;
  label?: string;
}

const sizeClasses: Record<StatusBadgeSize, string> = {
  sm: 'px-2 py-0.5 text-xs',
  md: 'px-2.5 py-0.5 text-xs',
  lg: 'px-3 py-1 text-sm'
};

const StatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  size = 'sm',
  className = '',
  label
}) => {
  return (
    <span className={`inline-flex items-center rounded-full font-medium ${getStatusColor(status)} ${sizeClasses[size]} ${className}`}>
      {getStatusIcon(status)}
      <span className="ml-1">{label || getStatusText(status)}</span>
    </span>
  );
};

export default StatusBadge;
